import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from './design-system/theme';

import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';
const environment =
  !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
    ? 'development'
    : 'production';

if (environment === 'production') {
  Sentry.init({
    dsn: 'https://a139595d2870ccdd00202cd2c378e6cf@o4508608097681408.ingest.us.sentry.io/4508653687865344',
    environment: environment,
    ignoreErrors: [
      'Unexpected error during sign-in: auth/network-request-failed Firebase: A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred. (auth/network-request-failed).',
      'auth/network-request-failed',
      'AxiosError: Network Error',
      'Could not establish connection. Receiving end does not exist.',
    ],
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ['error'],
      }),
      Sentry.replayIntegration(),
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation: useLocation,
        useNavigationType: useNavigationType,
        createRoutesFromChildren: createRoutesFromChildren,
        matchRoutes: matchRoutes,
      }),
    ],
    beforeSend(event) {
      if (event.level !== 'error') {
        return null;
      }
      return event;
    },

    tracesSampleRate: environment === 'production' ? 0.01 : 0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
